import { asStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import { getPortalDashboardUrl } from "@bezoned/shared/routes.js";
import {
  Button,
  Menu,
  MenuGroup,
  MenuItem,
  MenuItemLink,
  MenuList,
  MenuPopover,
  MenuTrigger,
} from "@fluentui/react-components";
import {
  EditRegular,
  NavigationRegular,
  SettingsRegular,
} from "@fluentui/react-icons";

import { env } from "../../../utils/env.js";

interface TeamListSideMenuProps {
  editMode: boolean;
  setEditMode: (editMode: boolean) => void;
}

const EditModeMenu = ({
  setEditMode,
}: {
  setEditMode: (editMode: boolean) => void;
}) => (
  <Button
    appearance="primary"
    onClick={asStableCallback(() => setEditMode(false))}
    type="button"
  >
    Close settings
  </Button>
);

const NormalModeMenu = ({
  setEditMode,
}: {
  setEditMode: (editMode: boolean) => void;
}) => (
  <Menu>
    <MenuTrigger disableButtonEnhancement>
      <Button appearance="subtle" icon={<NavigationRegular />} />
    </MenuTrigger>

    <MenuPopover>
      <MenuList>
        <MenuGroup>
          <MenuItem
            icon={<EditRegular />}
            onClick={asStableCallback(() => setEditMode(true))}
          >
            Settings
          </MenuItem>
        </MenuGroup>

        <MenuGroup>
          <MenuItemLink
            href={getPortalDashboardUrl(env.PUBLIC_PORTAL_URL)}
            icon={<SettingsRegular />}
            target="_blank"
          >
            Manage licenses
          </MenuItemLink>
        </MenuGroup>
      </MenuList>
    </MenuPopover>
  </Menu>
);

export const TeamListSideMenu = ({
  editMode,
  setEditMode,
}: TeamListSideMenuProps) =>
  editMode ? (
    <EditModeMenu setEditMode={setEditMode} />
  ) : (
    <NormalModeMenu setEditMode={setEditMode} />
  );
